/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InputAdminOTG
 */
export interface InputAdminOTG {
    /**
     * 
     * @type {string}
     * @memberof InputAdminOTG
     */
    name: string;
    /**
     * 
     * @type {number}
     * @memberof InputAdminOTG
     */
    osgId: number;
}

/**
 * Check if a given object implements the InputAdminOTG interface.
 */
export function instanceOfInputAdminOTG(value: object): boolean {
    if (!('name' in value)) return false;
    if (!('osgId' in value)) return false;
    return true;
}

export function InputAdminOTGFromJSON(json: any): InputAdminOTG {
    return InputAdminOTGFromJSONTyped(json, false);
}

export function InputAdminOTGFromJSONTyped(json: any, ignoreDiscriminator: boolean): InputAdminOTG {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'osgId': json['osgId'],
    };
}

export function InputAdminOTGToJSON(value?: InputAdminOTG | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'osgId': value['osgId'],
    };
}

